import styled from 'styled-components';

export const Wrapper = styled.div``;

export const HeadingWrapper = styled(Wrapper)`
  margin-bottom: 22px;
  margin-top: 20px;
`;

export const FileUploadWrapper = styled(Wrapper)`
  margin-top: 1em;
`;
